import { all, call, put, take, select } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import {
  LOGIN,
  AUTH_ANONYMOUS,
  CHECK_LOCAL_AUTH,
  RECOVERY_PASSWORD,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD,
  CHANGE_PASSWORD,
  LOGOUT,
  LOG_OUT_NOT_CLEAR_DATA,
} from '../type';
import {
  loginSuccessAction,
  loginErrorAction,
  authAnonymousErrorAction,
  authAnonymousSuccessAction,
  checkLocalAuthErrorAction,
  checkLocalAuthSuccessAction,
  recoveryPasswordSuccessAction,
  recoveryPasswordErrorAction,
  confirmVerifyCodeChangePasswordSuccessAction,
  confirmVerifyCodeChangePasswordErrorAction,
  changePasswordSuccessAction,
  changePasswordErrorAction,
  logoutErrorAction,
  checkLocalAuthNotClearDataSuccessAction,
} from '../action';

import {
  loadListPatientKinSuccessAction,
  resetListPatientKin,
} from '../../account/action';

import { checkAuthenticationStatus } from '../selector';
import { authService } from 'services';
import { history } from 'store';
import MessengerResource from 'common/resource/MessengerResource';

function* login() {
  while (1) {
    const action = yield take(LOGIN);
    const callback = get(action, 'payload.callback');
    try {
      const response = yield call(authService.login, action.payload);
      const patientId = get(response, 'patientId');
      if (patientId) {
        const params = {
          data: {
            patientId,
          },
        };
        const resPatient = yield call(
          authService.getPatientInformation,
          params,
        );
        yield put(loadListPatientKinSuccessAction(resPatient));
      }
      callback && callback(response);
      yield put(loginSuccessAction(response));
    } catch (error) {
      console.log('err', error);
      notification.error({
        message: MessengerResource.auth.loginError,
      });

      yield put(loginErrorAction(error));
    }
  }
}

function* loginAnonymous() {
  while (1) {
    const action = yield take(AUTH_ANONYMOUS);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(authService.loginAnonymous);
      callback && callback(response);

      yield put(authAnonymousSuccessAction(response));
    } catch (error) {
      yield put(authAnonymousErrorAction(error));
    }
  }
}

function* checkLocalAuth() {
  while (1) {
    yield take(CHECK_LOCAL_AUTH);
    try {
      const authStore = yield select(checkAuthenticationStatus);
      const { isAuthenticated, isUser, data } = authStore;
      let authData = {};

      if (!isAuthenticated) {
        if (isUser) {
          history.push('/login'); //push to login page
        } else {
          authData = yield call(authService.loginAnonymous);
        }
      } else {
        authData = data;
      }

      yield put(checkLocalAuthSuccessAction(authData));
    } catch (error) {
      yield put(checkLocalAuthErrorAction(error));
    }
  }
}

function* recoveryPassword() {
  while (1) {
    const action = yield take(RECOVERY_PASSWORD);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(authService.recoveryPassword, action.payload);
      notification.success({
        message: MessengerResource.verifyCode.sendCodeSuccess,
      });
      callback && callback(response);
      yield put(recoveryPasswordSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.auth.recoveryPassError,
        description: 'Error',
      });
      yield put(recoveryPasswordErrorAction(error));
    }
  }
}

function* confirmVerifyCodeChangePassword() {
  while (1) {
    const action = yield take(CONFIRM_VERIFY_CODE_CHANGE_PASSWORD);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        authService.confirmVerifyCodeChangePassword,
        action.payload,
      );
      callback && callback(response);

      yield put(confirmVerifyCodeChangePasswordSuccessAction(response));
    } catch (error) {
      yield put(confirmVerifyCodeChangePasswordErrorAction(error));
    }
  }
}

function* changePassword() {
  while (1) {
    const action = yield take(CHANGE_PASSWORD);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(authService.changePassword, action.payload);
      response.newPassword = action.payload.data.newPassword;
      callback && callback(response);

      yield put(changePasswordSuccessAction(response));
    } catch (error) {
      yield put(changePasswordErrorAction(error));
    }
  }
}

function* logOut() {
  while (1) {
    yield take(LOGOUT);
    try {
      const authData = yield call(authService.loginAnonymous);
      yield put(checkLocalAuthSuccessAction(authData));
      // yield put(logoutSuccessAction());
      yield put(resetListPatientKin());
    } catch (error) {
      yield put(logoutErrorAction(error));
    }
  }
}

function* logOutNotClearData() {
  while (1) {
    yield take(LOG_OUT_NOT_CLEAR_DATA);
    try {
      const authData = yield call(authService.loginAnonymous);
      yield put(checkLocalAuthNotClearDataSuccessAction(authData));
      // yield put(logoutSuccessAction());
      yield put(resetListPatientKin());
    } catch (error) {
      yield put(logoutErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([
    login(),
    loginAnonymous(),
    checkLocalAuth(),
    recoveryPassword(),
    confirmVerifyCodeChangePassword(),
    changePassword(),
    logOut(),
    logOutNotClearData(),
  ]);
}
